import * as Survey from "survey-react";

const google = window.google;

export default function GooglePlacesAutoComplete() {

var survey = window.survey;

var widget = {
    //the widget name. It should be unique and written in lowcase.
    name: 'googleplacesautocomplete',
    //the widget title. It is how it will appear on the toolbox of the SurveyJS Editor/Builder
    title: 'Google Places Address Autocomplete',
    //the name of the icon on the toolbox. We will leave it empty to use the standard one
    iconName: '',
    //If the widgets depends on third-party library(s) then here you may check if this library(s) is loaded
    widgetIsLoaded: function() {
        //return typeof $ == "function" && !!$.fn.select2; //return true if jQuery and select2 widget are loaded on the page

        return true; //we do not require anything so we just return true.
    },
    //SurveyJS library calls this function for every question to check, if it should use this widget instead of default rendering/behavior
    isFit: function(question) {
        //we return true if the type of question is textwithbutton
        return question.getType() === 'googleplacesautocomplete';

        //the following code will activate the widget for a text question with inputType equals to date
        //return question.getType() === 'text' && question.inputType === "date";
    },
    //Use this function to create a new class or add new properties or remove unneeded properties from your widget
    //activatedBy tells how your widget has been activated by: property, type or customType
    //property - it means that it will activated if a property of the existing question type is set to particular value, for example inputType = "date"
    //type - you are changing the behaviour of entire question type. For example render radiogroup question differently, have a fancy radio buttons
    //customType - you are creating a new type, like in our example "textwithbutton"
    activatedByChanged: function(activatedBy) {
        //we do not need to check acticatedBy parameter, since we will use our widget for customType only
        //We are creating a new class and derived it from text question type. It means that text model (properties and fuctions) will be available to us
        Survey.JsonObject.metaData.addClass(
            'googleplacesautocomplete',
            [],
            null,
            'text'
        );
        //signaturepad is derived from "empty" class - basic question class
        //Survey.JsonObject.metaData.addClass("signaturepad", [], null, "empty");

        //Add new property(s)
        //For more information go to https://Surveyjs.io/Examples/Builder/?id=addproperties#content-docs
        Survey.JsonObject.metaData.addProperties('googleplacesautocomplete', [
            { name: 'componentRestrictions' },
        ]);
    },
    //If you want to use the default question rendering then set this property to true. We do not need any default rendering, we will use our our htmlTemplate
    isDefaultRender: false,
    //You should use it if your set the isDefaultRender to false
     htmlTemplate:
         '<div><input style="width:100%" type="text" name="googleplacesautocomplete" id="googleplacesautocomplete" placeholder="Street Address"></div>',

    //The main function, rendering and two-way binding
    afterRender: function(question, el) {
        //el is our root element in htmlTemplate, is "div" in our case
        //get the text element

        var text = el.getElementsByTagName('input')[0];
        //set some properties
        text.inputType = question.inputType;
        text.placeholder = question.placeHolder;

        var places = new google.maps.places.Autocomplete(text);
        places.setFields(['formatted_address']);
        places.setComponentRestrictions(question.componentRestrictions);
        places.setTypes(['address']);
        google.maps.event.addListener(places, 'place_changed', function() {
            var place = places.getPlace();
            
            question.value = place.formatted_address;

            // survey.setVariable('addressValidated', false);
            // // may need a little validation here...
            // var address = '';
            // var fullAddress = '';
            // console.log(place.address_components);
            // if (
            //     extractFromObject(place.address_components, 'street_number') !=
            //     null
            // ) {
            //     address =
            //         extractFromObject(
            //             place.address_components,
            //             'street_number'
            //         ) +
            //         ' ' +
            //         extractFromObject(place.address_components, 'route');
            //     fullAddress = address + ', ';
            //     Survey.setVariable('address', address);
            //     fullAddress =
            //         fullAddress +
            //         extractFromObject(place.address_components, 'locality') +
            //         ', ';
            //     Survey.setVariable(
            //         'city',
            //         extractFromObject(place.address_components, 'locality')
            //     );
            //     fullAddress =
            //         fullAddress +
            //         extractFromObject(
            //             place.address_components,
            //             'administrative_area_level_1'
            //         ) +
            //         ' ';
            //     Survey.setVariable(
            //         'state',
            //         extractFromObject(
            //             place.address_components,
            //             'administrative_area_level_1'
            //         )
            //     );
            //     fullAddress =
            //         fullAddress +
            //         extractFromObject(place.address_components, 'postal_code');
            //     Survey.setVariable(
            //         'zip',
            //         extractFromObject(place.address_components, 'postal_code')
            //     );
            //     Survey.setVariable(
            //         'country',
            //         extractFromObjectLong(place.address_components, 'country')
            //     );
            //     Survey.setVariable('fullAddress', fullAddress);
            //     Survey.setVariable('addressValidated', true);
            //     question.value = text.value;
            //     console.log(Survey.getVariable('fullAddress'));
            // } else {
            //     alert('we need a complete address...');
            // }
        });

        //set the changed value into question value
        text.onchange = function() {
            question.value = text.value;
        };
        let onValueChangedCallback = function() {
            text.value = question.value ? question.value : '';
        };
        let onReadOnlyChangedCallback = function() {
            //alert('onReadOnlyChangedCallback')
            if (question.isReadOnly) {
                text.setAttribute('disabled', 'disabled');
            } else {
                text.removeAttribute('disabled');
            }
        };
        //if question becomes readonly/enabled add/remove disabled attribute
        question.readOnlyChangedCallback = onReadOnlyChangedCallback;
        //if the question value changed in the code, for example you have changed it in JavaScript
        question.valueChangedCallback = onValueChangedCallback;
        //set initial value
        onValueChangedCallback();
        //make elements disabled if needed
        onReadOnlyChangedCallback();
    },
    //Use it to destroy the widget. It is typically needed by jQuery widgets
    willUnmount: function(question, el) {
        //We do not need to clear anything in our simple example
        //Here is the example to destroy the image picker
        //var $el = $(el).find("select");
        //$el.data('picker').destroy();        
    },
};

function extractFromObject(object, key) {
    return (
        object
            .filter(component => component.types.indexOf(key) === 0)
            .map(item => item.short_name)
            .pop() || null
    );
}
function extractFromObjectLong(object, key) {
    return (
        object
            .filter(component => component.types.indexOf(key) === 0)
            .map(item => item.long_name)
            .pop() || null
    );
}

//Register our widget in singleton custom widget collection
Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, 'customtype');
}



// WEBPACK FOOTER //
// ./src/GooglePlacesAutoComplete.js